module.exports = {"thumbnail":"https://wnow-modules.s3.amazonaws.com/icon_stroke_news_articlelist.svg","tag":"GNM Media","affiliates":["kotv","kwtv"],"propTypes":{"alt":"PropTypes.string","src":"PropTypes.string","linkTo":"PropTypes.string","useHeightAndWidth":"PropTypes.bool","height":"PropTypes.number","width":"PropTypes.number"},"defaultProps":{"alt":"Feature Image","src":"http://kotv.images.worldnow.com/images/16345353_G.jpg","useHeightAndWidth":false,"linkTo":"","height":0,"width":0},"propChoices":{"affiliate":["kotv","kwtv"]}}


//////////////////
// WEBPACK FOOTER
// ./app/components/custom/ssr/Image/package.json
// module id = 1778
// module chunks = 0